import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      SEE_OTHER_WEEKS: "Se middager for andre uker i menyen",
      HERE: "her",
      MEALBOXES: "Matkasser",
      NO_RECIPES:
        "Ingen oppskrifter å vise for denne uken. Kom tilbake senere.",
      ORDER_THIS_MEALBOX: (name: string) => `Bestill ${name}`,
    },
    se: {
      SEE_OTHER_WEEKS: "Se middagar för andra veckor i menyn",
      HERE: "här",
      MEALBOXES: "Matkassar",
      NO_RECIPES: "Inga recept att visa för denna vecka. Kom tillbaka senare.",
      ORDER_THIS_MEALBOX: (name: string) => `Beställ ${name}`,
    },
    dk: {
      SEE_OTHER_WEEKS: "Se retter for andre uger i menuen",
      HERE: "her",
      MEALBOXES: "Måltidskasser",
      NO_RECIPES: "Ingen opskrifter at vise for denne uge. Kom tilbage senere.",
      ORDER_THIS_MEALBOX: (name: string) => `Bestil ${name}`,
    },
  } as const
)[language];
